module.exports = __webpack_public_path__ + "static/media/upArrowIcon.20be0236.svg";